import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react'; // Use state to re-run keyframe animations on click

export var useAnimateWithClick = function useAnimateWithClick(callback) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      shouldAnimate = _React$useState2[0],
      setShouldAnimate = _React$useState2[1];

  var onClickHandler = React.useCallback(function () {
    setShouldAnimate(true);
    callback && callback();
  }, [callback]);
  var onAnimationEnd = React.useCallback(function () {
    return setShouldAnimate(false);
  }, []);
  return {
    shouldAnimate: shouldAnimate,
    onAnimationEnd: onAnimationEnd,
    onClickHandler: onClickHandler
  };
};